import { Command } from "@ckeditor/ckeditor5-core";

export default class InsertEdithCustomWidgetCommand extends Command {
    execute({ content }) {
        const editor = this.editor;

        editor.model.change((writer) => {
            // 1. Crée le widget et son contenu
            const widget = writer.createElement("edithCustomWidget");
            const widgetContent = writer.createElement("edithCustomContent");
            writer.append(widgetContent, widget);
            // 2. Insère le widget à la sélection courante
            editor.model.insertContent(widget, editor.model.document.selection);
            // 3. Convertit le contenu HTML en fragment modèle
            const viewFragment = editor.data.processor.toView(content);
            const modelFragment = editor.data.toModel(viewFragment);
            // 4. Insère le fragment dans widgetContent (qui est désormais dans le document)
            writer.insert(modelFragment, widgetContent, "end");
            // 5. Place la sélection dans widgetContent pour pouvoir éditer directement
            writer.setSelection(widgetContent, "in");
        });
    }

    refresh() {
        this.isEnabled = true;
    }
}
